import { useQuery } from '@tanstack/react-query'
import InsightsAPI from '@/features/dashboard/api/insights/InsightsAPI'
import { QUERY } from '@/features/dashboard/api/insights/InsightsAPI.model'

interface IngredientsQueryProps {
  first_start_date: string
  first_end_date: string
  second_start_date: string
  second_end_date: string
  ingredient_type_filter: string
}

export function useIngredientsInsightsQuery(props: IngredientsQueryProps) {
  const {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date,
    ingredient_type_filter
  } = props

  const params = {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date,
    type: ingredient_type_filter
  }

  const totalSalesCountIngredients = useQuery({
    queryKey: [QUERY.TOTAL_SALES_COUNT_INGREDIENTS, params],
    queryFn: () => InsightsAPI.getTotalSalesCountIngredients(params)
  }).data

  const totalSalesValueIngredients = useQuery({
    queryKey: [QUERY.TOTAL_SALES_VALUE_INGREDIENTS, params],
    queryFn: () => InsightsAPI.getTotalSalesValueIngredients(params)
  }).data

  const totalSalesAveragesIngredients = useQuery({
    queryKey: [QUERY.TOTAL_SALES_AVERAGES_INGREDIENTS, params],
    queryFn: () => InsightsAPI.getTotalSalesAveragesIngredients(params)
  }).data

  const totalSalesCumulativeValueIngredients = useQuery({
    queryKey: [QUERY.TOTAL_SALES_CUMULATIVE_VALUE_INGREDIENTS, params],
    queryFn: () => InsightsAPI.getTotalSalesCumulativeValueIngredients(params)
  }).data

  return {
    totalSalesCountIngredients,
    totalSalesValueIngredients,
    totalSalesAveragesIngredients,
    totalSalesCumulativeValueIngredients
  }
}
